var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarrer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1293_11870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.875,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1293_11870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.7086V7.7086H10.5V8.7086H5.5ZM5.5 6.04193V5.04193H10.5V6.04193H5.5ZM4 10.3753H9C9.3 10.3753 9.57511 10.439 9.82533 10.5666C10.0751 10.6946 10.2889 10.8753 10.4667 11.1086L12 13.1086V3.74193C12 3.68638 11.9807 3.63904 11.942 3.59993C11.9029 3.56126 11.8556 3.54193 11.8 3.54193H4.2C4.14444 3.54193 4.09733 3.56126 4.05867 3.59993C4.01956 3.63904 4 3.68638 4 3.74193V10.3753ZM4.2 14.2086H11.5833L9.68333 11.7253C9.59444 11.6142 9.49156 11.5279 9.37467 11.4666C9.25822 11.4057 9.13333 11.3753 9 11.3753H4V14.0086C4 14.0642 4.01956 14.1115 4.05867 14.1506C4.09733 14.1893 4.14444 14.2086 4.2 14.2086ZM11.8 15.2086H4.2C3.86667 15.2086 3.58333 15.0919 3.35 14.8586C3.11667 14.6253 3 14.3419 3 14.0086V3.74193C3 3.4086 3.11667 3.12526 3.35 2.89193C3.58333 2.6586 3.86667 2.54193 4.2 2.54193H11.8C12.1333 2.54193 12.4167 2.6586 12.65 2.89193C12.8833 3.12526 13 3.4086 13 3.74193V14.0086C13 14.3419 12.8833 14.6253 12.65 14.8586C12.4167 15.0919 12.1333 15.2086 11.8 15.2086Z",
    fill: "#4F0696"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrer);
export default __webpack_public_path__ + "static/media/carrer.e1a7b2160c540070444ae1c2a4f0412e.svg";
export { ForwardRef as ReactComponent };